import React, {useState, useRef} from 'react';

import {usePopper} from 'react-popper';

import {ReactComponent as HelperIcon} from '../../../assets/svg/helper.svg';

import {HelperContainer} from './styled';

type Props = {
    content?: React.ReactNode | string;
    children?: React.ReactNode | string;
    maxWidth?: string;
    style?: React.CSSProperties;
};

export const Helper = ({content, children, maxWidth, style}: Props) => {
    const [referenceElement, setReferenceElement] = useState<HTMLDivElement | null>(null);
    const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null);
    const [visible, setVisible] = useState(false);
    const hideTimeout = useRef<number | null>(null);

    const {styles, attributes} = usePopper(referenceElement, popperElement, {
        placement: 'top',
        modifiers: [
            {name: 'offset', options: {offset: [0, 8]}},
            {name: 'flip', options: {padding: 8}},
        ],
    });

    const show = () => {
        if (hideTimeout.current) clearTimeout(hideTimeout.current);
        setVisible(true);
    };

    const hide = () => {
        hideTimeout.current = window.setTimeout(() => {
            setVisible(false);
        }, 200);
    };

    return (
        <div style={{position: 'relative', ...style}}>
            <div
                style={{color: '#939AA4', height: 18}}
                ref={setReferenceElement}
                onMouseEnter={show}
                onMouseLeave={hide}
            >
                {children ?? <HelperIcon width={18} height={18} />}
            </div>

            <HelperContainer
                ref={setPopperElement}
                style={{
                    ...styles.popper,
                    visibility: visible ? 'visible' : 'hidden',
                    pointerEvents: visible ? 'auto' : 'none',
                    opacity: visible ? 1 : 0,
                    transition: 'all 0.2s ease-in-out',
                }}
                maxWidth={maxWidth}
                {...attributes.popper}
                onMouseEnter={show}
                onMouseLeave={hide}
            >
                {content}
            </HelperContainer>
        </div>
    );
};
